import React from 'react';
import playButton from '../../../../assets/icons/play.png';
import { getYouTubeThumbnail } from '../caseTypeConstants';
import { TreatmentDetails } from '../treatmentDetails';

interface CaseTypeCardsProps {
    caseTypes: TreatmentDetails[];
    onLearnMore: (caseType: TreatmentDetails) => void;
}

const CaseTypeCard: React.FC<{
    caseType: TreatmentDetails;
    onClick: () => void;
}> = ({ caseType, onClick }) => (
    <div className="flex flex-col bg-white rounded-xl border-2 border-gray-200 p-6">
        <h4 className="text-lg font-bold text-gray-900">{caseType.label} Mechanics</h4>
        <p className="mt-2 text-sm text-gray-600 flex-grow">{caseType.description}</p>
        <div className="relative mt-4 cursor-pointer group" onClick={onClick}>
            <img
                src={getYouTubeThumbnail(caseType.learnMoreLink)}
                alt={`${caseType.label} Mechanics`}
                className="w-full h-auto rounded-lg"
                onError={(e) => {
                    e.currentTarget.style.display = 'none';
                }}
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black/40 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity">
                <img src={playButton} alt="Play" className="w-12 h-12" />
            </div>
        </div>
    </div>
);

export const CaseTypeCards: React.FC<CaseTypeCardsProps> = ({ caseTypes, onLearnMore }) => (
    <div className="w-full">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">Learn more about our case types</h2>
        <p className="text-base text-gray-600 mt-2 mb-8">
            Optimum alignment and aesthetics are included in all case types
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {caseTypes.map((caseType) => (
                <CaseTypeCard
                    key={caseType.key}
                    caseType={caseType}
                    onClick={() => onLearnMore(caseType)}
                />
            ))}
        </div>
    </div>
);
